import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import '../../styles/components/admin/AdminModal.css';

const AdminModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children,
  footer = null,
  size = 'medium' // small, medium, large
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="admin-modal-backdrop" onClick={handleBackdropClick}>
      <div className={`admin-modal ${size}`}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          {children}
        </div>

        {footer && (
          <div className="modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminModal;
